import { clsx } from 'clsx';
import { type FC, type ReactNode } from 'react';

import { SkeletonCardList } from '../SkeletonCardList/SkeletonCardList';

import styles from './ListingLayout.css';

type ListingLayoutProps = {
  banners: ReactNode;
  navigation: ReactNode;
  cards: ReactNode;
  similarCards: ReactNode;
  isFetching: boolean;
  isNarrow: boolean;
  pagination: ReactNode;
  seo: ReactNode;
  renderNoCards(): JSX.Element;
};

export const ListingLayout: FC<ListingLayoutProps> = ({
  banners,
  navigation,
  cards,
  pagination,
  seo,
  isNarrow,
  isFetching,
  similarCards,
  renderNoCards,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header-section']}>
        <div className={styles['navigation-wrapper']} data-testid="listing.navigation-wrapper">
          {navigation}
        </div>
        <div className={styles['seo-wrapper']}>{seo}</div>
        <div className={styles['banners-wrapper']}>{banners}</div>
      </div>
      <div className={styles['cards-wrapper']}>
        {isFetching && (
          <div className={styles['cards-loader']}>
            <SkeletonCardList isTop isNarrow={isNarrow} of={3} />
          </div>
        )}

        {!!cards && (
          <div className={clsx({ [styles['cards-hidden']]: isFetching })} data-testid="listing.cards">
            {cards}
          </div>
        )}

        {!isFetching && !cards && <div data-testid="listing.noCards">{renderNoCards()}</div>}
      </div>
      <div className={styles['pagination-wrapper']}>{pagination}</div>
      {!!similarCards && <div className={styles['similar-cards-wrapper']}>{similarCards}</div>}
    </div>
  );
};
